import { ChatMuteType, ChatMuteUntil } from 'src/@types/chat';
import { useLocales } from 'src/locales';

export enum ChatDetailsTitle {
  OVERVIEW = 'Overview',
  MEMBERS = 'Members',
  MEDIA = 'Media',
  FILES = 'Files',
  LINKS = 'Links',
  SETTINGS = 'Settings',
  DELETE = 'Delete',
  LEAVE = 'Leave',
  CALL_SCHEDULE = 'Call Schedule',
  TRANSCRIPTION = 'Transcription',
  PAST_SESSIONS = 'Past Sessions',
}

export type ChatMuteOptionsType = {
  title: string;
  icon: string;
  value: {
    mute: ChatMuteType | undefined;
    muteUntil: ChatMuteUntil | undefined;
  };
};

export const useChatMuteOptions = () => {
  const { translate } = useLocales();

  const chatMuteOptions: ChatMuteOptionsType[] = [
    {
      title: translate('communicate.create_modal.settings.not_muted'),
      icon: 'fluent:speaker-2-16-regular',
      value: {
        mute: ChatMuteType.NOTMUTED,
        muteUntil: undefined,
      },
    },
    {
      title: translate('communicate.create_modal.settings.mentions'),
      icon: 'fluent:speaker-off-16-regular',
      value: {
        mute: ChatMuteType.MENTIONS,
        muteUntil: undefined,
      },
    },
    {
      title: translate('communicate.create_modal.settings.mute_for_8_hours'),
      icon: 'fluent:speaker-off-16-regular',
      value: {
        mute: ChatMuteType.MUTEDUNTIL,
        muteUntil: ChatMuteUntil.HOURS_8,
      },
    },
    {
      title: translate('communicate.create_modal.settings.mute_for_1_day'),
      icon: 'fluent:speaker-off-16-regular',
      value: {
        mute: ChatMuteType.MUTEDUNTIL,
        muteUntil: ChatMuteUntil.DAY,
      },
    },
    {
      title: translate('communicate.create_modal.settings.mute_for_1_week'),
      icon: 'fluent:speaker-off-16-regular',
      value: {
        mute: ChatMuteType.MUTEDUNTIL,
        muteUntil: ChatMuteUntil.WEEK,
      },
    },
    {
      title: translate('communicate.create_modal.settings.always_muted'),
      icon: 'fluent:speaker-off-16-regular',
      value: {
        mute: ChatMuteType.MUTED,
        muteUntil: undefined,
      },
    },
  ];

  return chatMuteOptions;
};
